import { useQuery } from 'react-query';
import { searchListingsRequest } from '@api/listings/searchListingsRequest';
import { SearchListingQueryParams } from '@utils/types/searchListingsQueryParams';
import { FilterParamsType } from '@utils/types/searchListingsContext';
import { useEffect, useState } from 'react';

export function useSearchListingsAPI(filterParams: FilterParamsType) {
  const [qParams, setQParams] = useState<SearchListingQueryParams>();

  useEffect(() => {
    setQParams((prevQParams) => ({
      ...prevQParams,
      bounds: filterParams.mapBounds || undefined,
      start: filterParams.dates?.from?.toISOString(),
      end: filterParams.dates?.to?.toISOString(),
      amount_of_flexible_days_check_in: filterParams.fuzzyDatesOffset?.from,
      amount_of_flexible_days_check_out: filterParams.fuzzyDatesOffset?.to,
      amenities: filterParams.amenities,
      collections: filterParams.market ? [filterParams.market] : undefined,
      neighborhoods: filterParams.neighborhoods || undefined,
      monthly_price_min: filterParams.price?.min as number,
      monthly_price_max: filterParams.price?.max as number,
      bathrooms_min: filterParams.bathrooms?.min as number,
      bathrooms_max: filterParams.bathrooms?.max as number,
      bedrooms_min: filterParams.bedrooms?.min as number,
      bedrooms_max: filterParams.bedrooms?.max as number,
      beds_min: filterParams.beds?.min as number,
      beds_max: filterParams.beds?.max as number,
      guests: filterParams.guests,
      rules: filterParams.petFriendly ? ['pets_friendly'] : undefined,
      title: filterParams.search || undefined,
    }));
  }, [filterParams]);

  return useQuery(
    ['searchListings', qParams],
    () => searchListingsRequest(qParams),
    {
      enabled: !!qParams,
      retry: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );
}
